/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { RicBeaconButton, RicBeaconModal } from '../shared/BeaconRegister';
import { Box, Grid } from '@mui/material';

import connectWithModalStore from '../../reducers/connectWithModalStore';
import CountDownTimer from '../shared/CountDownTimer';
import { logoutUrl } from "../shared/Links";
import serviceErrorIcon from '../../assets/images/Error_Icon.svg';
import { dispatchOverlayLoad } from "../shared/Analytics";
import axiosInstance from "../../actions/AxiosInstance";
import api from "../../actions/EndPoints";
import workerScript from './interval.worker';
import {
    log,
    resetMGPSessionTimer,
    setLastRequestTime,
    setSTModalActive,
    getSTModalActive,
    removeSTModalActive,
    closeModal,
    showModal
} from '../../Utils';


const SessionTimer = connectWithModalStore(({ state, dispatch, applicationConfig }) => {
    const { sessionTimerModal } = state;
    const [modalIsOpen, setModalOpen] = React.useState(false);
    const [logOutLoader, setLogoutLoader] = React.useState(false);
    const [disableKOBtn, setDisablekeepMeOnline] = React.useState(false);
    const [keepSession, setKeepSession] = React.useState(false);
    const [countdownActive, setCountdownActive] = React.useState(false);
    const countDownTime = 120000;
    const events = ['click'];
    
    const SESSION_TIMEOUT_MINUTES = 28; 
    
    const openSessionModal = () => {
        showModal('session-timer');
        dispatchOverlayLoad('Session Timed Out');
        setModalOpen(true);
        setCountdownActive(true);
    };
    
    const closeSessionModal = () => {
        closeModal('session-timer');
        setModalOpen(false);
        setCountdownActive(false);
    }
    
    const continueSession = () => {
        closeSessionModal();
        removeSTModalActive();
        setKeepSession(true);
        setLastRequestTime();
        log(console.log("User selected to Stay Online"));
    };
    
    const logOutRIT = () => {
        closeSessionModal();
        setLogoutLoader(true);
        window.location.href = logoutUrl;
        const keysToRemove = ['emailInv', 'invitePinNumber', 'lastRequestTime'];
        keysToRemove.forEach(k => localStorage.removeItem(k));
        setModalOpen(false);
        setTimeout(() => {
            closeModal('session-timer');
            removeSTModalActive();
        }, 5000);
    };
    
    // To set and reset session timer
    React.useEffect(() => {
        let resetTokenExpiration = false;
        let autoTime;
        let modalOpen;
        let lastRequestTimeMilliseconds = JSON.parse(localStorage.getItem('lastRequestTime')) || null;
        let timeInSecondsSinceLastRequest = Math.ceil((Date.now() - lastRequestTimeMilliseconds) / 1000);
        let timeInSecondsUntilExpire = (SESSION_TIMEOUT_MINUTES * 60) - timeInSecondsSinceLastRequest;
        console.log('timeInSecondsUntilExpire', timeInSecondsUntilExpire);
        
        const logOutRITTabs = () => {
            setLogoutLoader(true);
            window.location.href = logoutUrl;
            localStorage.removeItem('lastRequestTime');
            setTimeout(() => {
                closeSessionModal();
                setModalOpen(false);
                removeSTModalActive();
            }, 5000);
        };
        
        const resetAutoTimer = () => {
            clearTimeout(autoTime);
            setLastRequestTime();
            modalOpen = false;
            log(console.log('Auto Timer Reset'));
        };
        const resetAutoTimerTabs = () => {
            clearTimeout(autoTime);
            modalOpen = false;
            log(console.log('Auto Timer Reset'));
        };
        const resetLastRequestTime = async () => {
            lastRequestTimeMilliseconds = JSON.parse(localStorage.getItem('lastRequestTime')) || null;
            timeInSecondsSinceLastRequest = Math.ceil((Date.now() - lastRequestTimeMilliseconds) / 1000);
            timeInSecondsUntilExpire = (SESSION_TIMEOUT_MINUTES * 60) - timeInSecondsSinceLastRequest;
            
            if (modalOpen && timeInSecondsUntilExpire > 0 && !keepSession) {
                log(console.log('timer reset in other tab'));
                resetAutoTimerTabs();
                modalOpen = false;
                closeSessionModal();
                removeSTModalActive();
            }
            // user logged out in other tab
            if (modalOpen && !lastRequestTimeMilliseconds) {
                log(console.log('user logged out in other tab'));
                logOutRITTabs();
                modalOpen = false;
            }
            if (timeInSecondsUntilExpire === 0 && !modalIsOpen) {
                setSTModalActive();
                openSessionModal();
                console.log('sessionTimerModal', modalIsOpen);
                console.log('getSTModalActive', getSTModalActive());
                setKeepSession(false);
                modalOpen = true;
                dispatchOverlayLoad('Session Timed Out');
                autoTime = setTimeout(() => {
                    setLogoutLoader(true);
                    setDisablekeepMeOnline(true);
                    window.location.href = logoutUrl;
                    setTimeout(() => {
                        showModal('session-timer')
                        removeSTModalActive();
                    }, 5000);
                    log(console.log('Your Timer Is Out , You are logged out'));
                }, countDownTime);
                const el = document.getElementById("keep-session");
                Object.keys(events).forEach((key) => {
                    el.addEventListener(events[key], resetAutoTimer);
                });
            }
            // If modal is open in multiple tabs and keep me online is selected
            if (modalIsOpen && timeInSecondsUntilExpire > 0) {
                log(console.log('timer reset in other tab'));
                closeSessionModal();
                removeSTModalActive();
                modalOpen = false;
            }
            if (modalIsOpen && timeInSecondsUntilExpire === -120) {
                log(console.log('timeInSecondsUntilExpire time out', timeInSecondsUntilExpire));
                closeSessionModal();
                removeSTModalActive();
            }
        };
        if (!resetTokenExpiration && lastRequestTimeMilliseconds && (timeInSecondsUntilExpire < 1800) && (timeInSecondsUntilExpire > 0)) {
            setInterval(() => resetLastRequestTime(), 1000);
        }
        return () => {
            resetTokenExpiration = true;
        }
    }, [events, dispatch, keepSession, sessionTimerModal]);
    
    // Keep the token alive so that user is still authenticated
    // User can only logout using logout btn on overlay or shared-nav and timeout
    React.useEffect(() => {
        let resetTokenExpiration = false;
        const testWorker = new Worker(workerScript);
        const establishSessionAffinity = async () => {
            try {
                const sessionAffiinityData = await axiosInstance.get(api.sessionAffinity, {
                    headers: {
                        apiKey: applicationConfig.apiKey,
                    }
                });
                resetMGPSessionTimer();
                if (sessionAffiinityData) {
                    log(console.log('success'));
                }
            } catch (error) {
                log(console.log(error));
            }
        };
        if (!resetTokenExpiration) {
            testWorker.postMessage('start');
            testWorker.onmessage = function (event) {
                if (event.data === 'timerCompleted') {
                    establishSessionAffinity();
                }
            }
            
        }
        
        return () => {
            testWorker.terminate();
            resetTokenExpiration = true;
        }
    }, []);
    
    return (
        <RicBeaconModal
            id="session-timer"
        >
            <Box id="session-timer-container" className='beacon-on-light beacon-theme-modern-outlook'>
                <Box id='session-timer-content-container'>
                    <Box pb='12px' id='error-img-container'>
                        <img src={serviceErrorIcon} alt="loading-error" id={`session-timer-error-img}`} />
                    </Box>
                    <Box className='b-typography-serif--headline--300 b-font-weight-bold' id='session-timer-title' pb='16px'>
                        You are about to be logged out
                    </Box>
                    <Box className='b-typography-sans-serif--body--100' id='session-timer-notice' pb='16px'>
                        We have noticed that you have been inactive for a while. For your
                        security, we&apos;ll automatically log you out in approximately{' '}
                        <span id="session-timer-counter" className='b-font-weight-bold'>
                            <CountDownTimer 
                                countdownActive={countdownActive}
                                countDownTime={!logOutLoader ? countDownTime / 1000 : 0}
                            />
                            .
                        </span>
                    </Box>
                    <Box id="button-disclosure" className='b-typography-sans-serif--body--100 b-font-weight-bold' pb='32px'>
                        Click &quot;Keep Me Online&quot; to continue using your online accounts.
                        If you&apos;re done, you may click &quot;Log Out&quot;.
                    </Box>
                </Box>
                <Box slot='action-zone' className='fixed' id='session-timer-button-container'>
                    <Grid container spacing={3} id='session-timer-button-grid-container'>
                        <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
                            <RicBeaconButton
                                disabled={logOutLoader}
                                id="logout"
                                variant='secondary'
                                onClick={logOutRIT}
                                style={{ width: '100%' }}
                            >
                                Log Out
                            </RicBeaconButton>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
                            <RicBeaconButton
                                disabled={disableKOBtn}
                                id="keep-session"
                                onClick={continueSession}
                                style={{ width: '100%' }}
                            >
                                Keep Me Online
                            </RicBeaconButton>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </RicBeaconModal>
    );
});

export default function SessionTimerModal({ applicationConfig }) {
    return <SessionTimer applicationConfig={applicationConfig} />;
}
